import { Icon, Table } from 'antd';
import moment from 'moment';
import { Permission } from 'components/page/index';
import { PopDeleteConfirm } from 'components/ui/index';
import PERMISSIONS from 'config/app-permission.config';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import { mapToAPIOrderStr } from 'utils/common';
import { toTimezone } from 'utils/dateTimeUtils';
import classNames from 'classnames/bind';
import { getStore } from 'utils/localStorage';
import { injectIntl } from 'react-intl';
import { setRouteInfo } from '../../../components/page/TaskDetails/flow/actions';
import { setModules } from '../../../components/page/DetailsSubpanels/flow/actions';
import {
  setRowSelection,
  tryFetchDataByView,
  tryDeleteClientByType,
  setPageSize,
  setSorter,
  setPaginationStatus,
  resetColumnsAndData
} from '../flow/actions';
import { getSorter } from '../flow/utils';
import styles from '../ObjectList.less';

const cx = classNames.bind(styles);
const {
  FieldTypes,
  DefaultPageConfigs,
  PhantomId,
  DateTimeConfigs,
  LocalStorageKeys,
} = Enums;
const { DefaultDateFormat } = DateTimeConfigs;
const { RouteInfo } = LocalStorageKeys;
const {
  DateOnly,
  DateTime,
  Email,
  LongText,
  Lookup,
  NumberInput,
  PickList,
  TextInput,
} = FieldTypes;
const { Options, PageSize } = DefaultPageConfigs;

class TableWrapper extends Component {
  state= {
    loading: false,
  }

  componentDidMount() {
    this.getTableData();
    this.props.setModules([]);
  }

  componentWillUnmount() {
    this.props.resetColumnsAndData();
    this.props.setRouteInfo('');
  }

  getTableData = async () => {
    this.setState({ loading: true });
    const {
      activeViewId,
      objectType,
      PageSizeValue,
      sorters,
    } = this.props;
    const viewId = _.isEmpty(getStore(RouteInfo)) ? activeViewId[objectType] : PhantomId;
    const sorterInfo = getSorter(activeViewId[objectType], sorters, objectType);
    await this.props.tryFetchDataByView(
      objectType,
      viewId,
      {
        page: 1,
        per_page: PageSizeValue,
        orderBy: sorterInfo.orderBy,
        sortedBy: mapToAPIOrderStr(sorterInfo.sortedBy),
      },
    );
    this.setState({ loading: false });
  }

  rowClassName = (record) => {
    const {
      objectType, theme, activeViewId, columns
    } = this.props;
    let todayRow = '';
    const todayDate = moment().format(DefaultDateFormat);
    // this condition is about to check the view is "My View" or not,
    // and then check if there is a column called "Created Date", and final is about if there are any date showed on the table match the local date.
    // there are two situations of the view will be "My View", one is from dashboard(View More) and one is changed the view by user.
    columns.forEach((value) => {
      if (
        (!_.isEmpty(getStore(RouteInfo)) || activeViewId[objectType] === PhantomId) &&
        !_.isEmpty(value) &&
        value.field_name === 'created_at' &&
        record &&
        record.created_at &&
        toTimezone(record.created_at, value.crm_data_type === DateTime).indexOf(todayDate) === 0
      ) {
        todayRow = `${theme}-today-row`;
      }
    });
    return todayRow;
  }

  handleDeleteClick = (id) => {
    const {
      activeViewId,
      objectType,
      tableParams,
      meta,
      routeInfo,
    } = this.props;
    const viewId = _.isEmpty(routeInfo) ? activeViewId[objectType] : PhantomId;
    this.props.tryDeleteClientByType(objectType, id, tableParams, meta, viewId);
  }

  handleSelectionChange = selectedKeys => this.props.setRowSelection(selectedKeys)

  handleTableChange = (pagination, filters, sorter) => {
    const {
      activeViewId,
      objectType,
      routeInfo,
      tableParams
    } = this.props;
    const viewId = _.isEmpty(routeInfo) ? activeViewId[objectType] : PhantomId;
    let paginationParams = {};
    let searchParams = {};
    let sorterParams = {};
    if (!_.isEmpty(pagination)) {
      const { current, pageSize } = pagination;
      paginationParams = {
        page: current,
        per_page: pageSize,
      };
    }
    if (!_.isEmpty(tableParams.search)) {
      searchParams = {
        search: tableParams.search
      };
    }
    if (!_.isEmpty(sorter)) {
      sorterParams = {
        orderBy: sorter.column.columnId,
        sortedBy: mapToAPIOrderStr(sorter.order),
      };
      this.props.setSorter({
        objectType,
        viewId,
        orderBy: sorter.column.columnId,
        sortedBy: sorter.order,
      });
    } else {
      // When the third click column header, clean sorter;
      sorterParams = {
        orderBy: '',
        sortedBy: '',
      };
      this.props.setSorter({
        objectType,
        viewId,
        orderBy: '',
        sortedBy: ''
      });
    }
    this.props.setPageSize(paginationParams.per_page);
    return this.props.tryFetchDataByView(objectType, viewId, { ...paginationParams, ...searchParams, ...sorterParams });
  }

  parsePagination = () => {
    const { PageSizeValue, isShowPagination, meta } = this.props;
    const { pagination } = meta;
    let extraParams = {};
    if (!_.isEmpty(pagination)) {
      extraParams = {
        current: pagination.current_page,
        pageSize: PageSizeValue,
        total: pagination.total,
      };
    }
    return {
      className: `stickToRight ${isShowPagination ? '' : 'hide'}`,
      defaultPageSize: PageSize,
      pageSizeOptions: Options,
      showSizeChanger: true,
      showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
      ...extraParams,
    };
  }

  renderColumnByType = (type, column) => {
    const {
      theme, activeViewId, sorters, objectType
    } = this.props;
    const sorter = getSorter(activeViewId[objectType], sorters, objectType);
    let configs;
    // Hide c__email column temporarily
    if (column.field_name === 'c__email') {
      configs = {};
    } else {
      configs = {
        title: column.field_label,
        dataIndex: column.field_name,
        // customized property 'columnId', used by table sorter
        columnId: column.id,
        sorter: true,
        sortOrder: column.id === sorter.orderBy ? sorter.sortedBy : '',
      };
    }
    // const configs = {
    //   title: column.field_label,
    //   dataIndex: column.field_name,
    //   // customized property 'columnId', used by table sorter
    //   columnId: column.id,
    //   sorter: true,
    //   sortOrder: column.id === sorter.orderBy ? sorter.sortedBy : '',
    // };

    const extraConfigs = {};

    switch (type) {
      case DateOnly:
      case DateTime:
        extraConfigs.render = text => toTimezone(text, type === DateTime);
        break;
      case Lookup:
        if (column.field_name === 'target_account_id') {
          extraConfigs.render = (lookup, record) => {
            if (record && record.target_account_id && record.target_account_id.id) {
              return (
                <Link
                  className="account-theme-text"
                  to={`accounts/${record.target_account_id.id}`}
                >
                  {lookup}
                </Link>
              );
            }
            return lookup;
          };
        }
        extraConfigs.dataIndex = `${column.field_name}.${column.lookup_own_field_name}`;
        break;
      case PickList:
      case Email:
      case LongText:
      case NumberInput:
      case TextInput:
        // As requested, we use Name and Email fields as a entry point to object details
        if (column.field_name === 'name') {
          extraConfigs.render = (text, record) => (
            <Link
              className={`${theme}-theme-text`}
              to={`${objectType}/${record.id}`}
            >
              {text}
            </Link>
          );
        }
        break;
      default:
        throw new Error('No such type is found when set up column.');
    }

    return {
      ...configs,
      ...extraConfigs,
    };
  }

  renderColumns = () => {
    const { objectType, columns } = this.props;
    const me = this;
    const newColumns = columns.map(column => me.renderColumnByType(column.crm_data_type, column));
    newColumns.unshift({
      title: '',
      key: 'actions',
      width: 30,
      render: (text, record) => (
        <Permission permission={PERMISSIONS[`${objectType.toUpperCase()}_DELETE`]}>
          <PopDeleteConfirm
            onConfirm={() => me.handleDeleteClick(record.id)}
            placement="right"
          >
            <Icon className="cursor-pointer" size="small" type="delete" />
          </PopDeleteConfirm>
        </Permission>
      ),
    });
    return newColumns;
  }

  render() {
    const {
      data,
      intl,
      selectedRowKeys,
      isShowPagination
    } = this.props;

    return (
      <Fragment>
        <div
          onClick={this.props.setPaginationStatus}
          className={classNames(cx('pagination-toggle-btn'), 'cursor-pointer')}
          title={intl.formatMessage({ id: `page.objectList.tooltip.${isShowPagination ? 'hide' : 'show'}` })}
        >
          <Icon type={isShowPagination ? 'double-right' : 'double-left'} className={cx('arrow-icon')} />
        </div>
        <Table
          columns={this.renderColumns()}
          dataSource={data}
          rowClassName={this.rowClassName}
          onChange={this.handleTableChange}
          pagination={this.parsePagination()}
          rowKey="id"
          rowSelection={{
            selectedRowKeys,
            onChange: this.handleSelectionChange,
          }}
          size="small"
          loading={this.state.loading}
        />
      </Fragment>
    );
  }
}


TableWrapper.propTypes = {
  activeViewId: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired,
  selectedRowKeys: PropTypes.array.isRequired,
  tableParams: PropTypes.object.isRequired,
  PageSizeValue: PropTypes.number.isRequired,
  routeInfo: PropTypes.string.isRequired,
  sorters: PropTypes.object.isRequired,
  isShowPagination: PropTypes.bool.isRequired,
  setRowSelection: PropTypes.func.isRequired,
  tryFetchDataByView: PropTypes.func.isRequired,
  tryDeleteClientByType: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
  setRouteInfo: PropTypes.func.isRequired,
  setModules: PropTypes.func.isRequired,
  setSorter: PropTypes.func.isRequired,
  setPaginationStatus: PropTypes.func.isRequired,
  resetColumnsAndData: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  objectList, taskDetails
}) => ({
  activeViewId: objectList.activeViewId,
  columns: objectList.columns,
  data: objectList.data,
  meta: objectList.meta,
  selectedRowKeys: objectList.selectedRowKeys,
  tableParams: objectList.tableParams,
  PageSizeValue: objectList.PageSizeValue,
  routeInfo: taskDetails.routeInfo,
  sorters: objectList.sorters,
  isShowPagination: objectList.isShowPagination,
});

const mapDispatchToProps = {
  setRowSelection,
  tryFetchDataByView,
  tryDeleteClientByType,
  setPageSize,
  setRouteInfo,
  setModules,
  setSorter,
  setPaginationStatus,
  resetColumnsAndData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TableWrapper));



// WEBPACK FOOTER //
// ./src/views/ObjectList/components/Table.jsx